export const SET_NAV_COLLAPSE = "SET_NAV_COLLAPSE";
